import * as style from "./OLSTrendLineTooltip.css";

interface OLSTrendLineTooltipProps {
  time_purchase: number;
  slope: number;
  intercept: number;
  r_squared: number;
  nis3: number;
}

/**
 * Renders the tooltip content for the OLS Trend Line in the accuracy chart.
 * Shows the regression equation, R² and the predicted (trend) value.
 */
export function OLSTrendLineTooltip({
  intercept,
  nis3,
  r_squared,
  slope,
  time_purchase
}: OLSTrendLineTooltipProps) {
  const interceptStr =
    intercept >= 0
      ? `+ ${Math.abs(intercept).toFixed(4)}`
      : `-${Math.abs(intercept).toFixed(4)}`;
  const equation = `<strong>NIS3_OD</strong> = ${slope.toFixed(
    4
  )} × time_purchase ${interceptStr}`;

  return `
    <div class="${style.olsTrendLineTooltipTooltipWrapper}">
      <div class="${style.olsTrendLineTooltipHeader}">
        <span class="${style.olsTrendLineTooltipSwatch}"></span>
        <div class="${style.olsTrendLineTooltipTitle}">OLS Trend Line</div>
      </div>
      <div class="${style.olsTrendLineTooltipEquation}">${equation}</div>
      <div class="${style.olsTrendLineTooltipBadges}">
        <span class="${style.olsTrendLineTooltipBadge}">R² = ${r_squared.toFixed(4)}</span>
      </div>
      <div class="${style.olsTrendLineTooltipColumn}">
        <div class="${style.olsTrendLineTooltipRow}">
          <div class="${style.olsTrendLineTooltipLabel}">Purchase:</div>
          <div>${time_purchase.toFixed(4)}</div>
        </div>
        <div class="${style.olsTrendLineTooltipRow}">
          <div class="${style.olsTrendLineTooltipLabel}">Sales:</div>
          <div>${nis3.toFixed(4)} (trend)</div>
        </div>
      </div>
    </div>
  `;
}
